interface SubnavigationItem {
  label: string
  items?: SubnavigationDropdownItem[]
}

export interface SubnavigationDropdownItem {
  label: string
  id: string
}

const data: SubnavigationItem[] = [
  {
    label: `Collection`,
    items: [
      {
        label: `Libraries`,
        id: `libraries`,
      },
      {
        label: `Cloud Sources`,
        id: `cloud-sources`,
      },
      {
        label: `Source Functions`,
        id: `source-functions`,
      },
      {
        label: `API`,
        id: `api`,
      },
    ],
  },
  {
    label: `Processing`,
    items: [
      {
        label: `Validation and Transformation`,
        id: `validation-and-transformation`,
      },
      {
        label: `Deduplication`,
        id: `deduplication`,
      },
      {
        label: `GDPR Suppression and Deletion`,
        id: `gdpr-suppression-and-deletion`,
      },
    ],
  },
  {
    label: `Aggregation`,
    items: [
      {
        label: `Identity Resolution`,
        id: `identity-resolution`,
      },
      {
        label: `Profile API`,
        id: `profile-api`,
      },
      {
        label: `Reverse ETL`,
        id: `reverse-etl`,
      },
      {
        label: `Audience Creation`,
        id: `audience-creation`,
      },
    ],
  },
  {
    label: `Delivery`,
    items: [
      {
        label: `Centrifuge`,
        id: `centrifuge`,
      },
      {
        label: `Destinations`,
        id: `destinations`,
      },
      {
        label: `Warehouses / ETL`,
        id: `warehouses-etl`,
      },
    ],
  },
]

export default data
